import React, { useEffect, useState } from "react";
import { getPublicContents, getContentByPublicId } from "../api/publicContent.api";
import "../index.css"; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import DetailsRenderer from './DetailsRenderer';

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getPublicContents("project");
        const withDetails = await Promise.all( 
          data.map(async (p) => { 
            const full = await getContentByPublicId(p.public_id); 
            return full; 
          }) 
        );
        setProjects(withDetails);
      } catch (err) {
        setError("Failed to load projects.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>
      <div className="container-fluid col-lg-10 col-md-6 py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className=" accordion" id="projectsAccordion">
          <div className="accordion-item border-0">
            {projects.map(p => (
              <React.Fragment key={p.public_id}>
                <div
                  className="project-box"
                  data-bs-toggle="collapse"
                  data-bs-target={`#project${p.public_id}`}
                >
                    <span><h3 style={{color:"white"}}>{p.title}</h3><p><b>Title: </b> {p.descr}</p></span>
                  <span><i class="bi bi-caret-down" style={{fontSize:30}}></i></span>
                </div>
                <div
                  id={`project${p.public_id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#projectsAccordion"
                >
                  <div className="project-desc">
                    <b>Duration: </b> <p><strong>Start Date:</strong>{" "}
                    {new Date(p.date).toLocaleDateString()}</p>
                    <DetailsRenderer type="project" details={p.details} />
                  </div>
                </div>
              </React.Fragment>
            ))}

          </div>
        </div>
      </div>
    </>
  );
}
